import { useMutation } from "@tanstack/react-query"
import { api } from "@/api"

interface FeedbackData {
    summary: string
    feedback_type: "positive" | "negative"
    billId: string
    profileId: string
    feedback_text?: string
}

interface FeedbackResponse {
    message: string
    success: boolean
}

const sendFeedback = async (data: FeedbackData): Promise<FeedbackResponse> => {
    const requestBody: any = {
        summary: data.summary,
        feedback_type: data.feedback_type,
        bill_id: data.billId,
        personalization_profile_id: data.profileId,
    }

    // Add feedback_text if provided
    if (data.feedback_text) {
        requestBody.feedback_text = data.feedback_text
    }

    const response = await api.post("/api/personalization/bill-summaries/feedback/", requestBody)

    return await response.json()
}

export const useFeedbackMutation = () => {
    return useMutation({
        mutationFn: sendFeedback,
        onSuccess: (data) => {
            console.log("Feedback sent successfully:", data.message)
        },
        onError: (error) => {
            console.error("Failed to send feedback:", error)
        },
    })
}
